
const __getArray = obj => {
    let s;
    const arr = [];
    for (s in obj) {
        if (!obj.hasOwnProperty(s) || isNaN(parseInt(s))) continue;
        arr[parseInt(s)] = obj[s];
    }
    return arr;
};

const __getIdsArray = obj => {
    let s;
    const arr = [];
    for (s in obj) {
        if (!obj.hasOwnProperty(s)) continue;
        arr.push(s);
    }
    return arr;
};

const __getReview = data => {
    return data.sections[0];
};

const __getConfigSection = data => {
    return data.sections[1];
};

const __getFixSection = data => {
    return data.sections[2];
};

const _initData = () => {
    const data = require('./data');

    const result = {
        reviewIdsMap: [],
        fixIdsMap: [],
        valuesMap: {
            none: []
        }
    };

    let obj = __getReview(data).numbers;
    let s;
    for (s in obj) {
        if (!obj.hasOwnProperty(s)) continue;
        result.valuesMap[s] = __getArray(obj[s]);
    }
    const arr = result.valuesMap[s];
    result.valuesMap.none = arr.map(() => { return 0; });
    result.reviewIdsMap = __getIdsArray(obj[s]);


    result.fixIdsMap = __getFixSection(data).details.map(item => item.id);

    obj = __getConfigSection(data).numbers;
    result.calculationConfig = obj;
    result.featuresIdsMap = __getIdsArray(obj.features);

    // console.log(result)

    return result;
}

const _getSelectedPresetValues = function () {
    return this.data.valuesMap[this.selectedPreset];
};

const _getValuesSet = function () {
    return this.valuesSet;
};

const _selectPreset = function (key) {
    if (!this.data.valuesMap.hasOwnProperty(key)) return this.selectedPreset;
    this.selectedPreset = key;
    return this.selectedPreset;
};

const _selectReviewItem = function (index) {
    if (index < 0 || index > this.data.reviewIdsMap.length - 1) return this._selectedReviewIndex;
    this._selectedReviewIndex = index;
    return this._selectedReviewIndex;
};

const _getSelectedReviewItemId = function () {
    return this.data.reviewIdsMap[this._selectedReviewIndex];
};

const _getSelectedReviewItemI = function () {
    return this._selectedReviewIndex;
};

const _getSelectedReviewCurrentValue = function () {
    const valuesSet = this.getSelectedPresetValues();
    return valuesSet[this._selectedReviewIndex];
};

const _selectFixItem = function (index) {
    if (index < 0 || index > this.data.fixIdsMap.length - 1) return this._selectedFixIndex;
    this._selectedFixIndex = index;

    let j = 0;
    let b = true;
    while (j < this._featuresSelected.length && b) {
        if (this._featuresSelected[j] === index) {
            this._selectedFixI = j;
            b = false;
        }
        j++;
    }

    return this._selectedFixIndex;
};

const _nextFixItem = function (index) {
    if (index < 0 || index > this._featuresSelected.length - 1) return this._selectedFixI;
    this._selectedFixI++;
    if (this._selectedFixI > this._featuresSelected.length - 1) this._selectedFixI = 0;
    this._selectedFixIndex = this._featuresSelected[this._selectedFixI];
    return this._selectedFixI;
};

const _getSelectedFixItemId = function () {
    return this.data.fixIdsMap[this._selectedFixIndex];
};

const _getSelectedFixIndex = function () {
    return this._selectedFixIndex;
};

const _getFeatureItemId = function (i) {
    return this.data.featuresIdsMap[i];
};

const _getSelectedFeatureItemsIds = function () {
    return this._featuresSelected.map(index => { return this.getFeatureItemId(index); });
};

const _getFeaturesStates = function () {
    return this._featuresStates;
};

const _getFeatureState = function (i) {
    if (i < 0 || i > this.numFeatures - 1) return false;
    return this._featuresStates[i];
};

const _getTotalRisk = function () {
    return this._totalRisk * 100;
};

const _getRisks = function () {
    return this._risks;
};

const _toggleFeature = function (i) {
    if (i < 0 || i > this.numFeatures - 1) return;
    this._featuresStates[i] = !this._featuresStates[i];
    if (this._featuresStates[i]) {
        this._featuresSelected.push(i);
        this._featuresSelected = this._featuresSelected.sort();
        this._selectedFixIndex = i;
        this._selectedFixI = this._featuresSelected.length - 1;
    } else {

        let j = 0;
        let b = true;
        while (j < this._featuresSelected.length && b) {
            if (this._featuresSelected[j] === i) {
                this._featuresSelected.splice(j, 1);
                b = false;
            }
            j++;
        }

        if (this._selectedFixIndex === i) {
            if (this._featuresSelected.length > 0) {
                this._selectedFixI = this._featuresSelected.length - 1;
                this._selectedFixIndex = this._featuresSelected[this._selectedFixI];
            } else {
                this._selectedFixI = -1;
                this._selectedFixIndex = -1;
            }

        }

    }
    this.isValuesSetBlank = this._featuresSelected.length < 1;

    if (this.isValuesSetBlank) {
        this._totalRisk = 0;
        this.valuesSet = [].concat(this.data.valuesMap.none);
        return;
    }

    this.valuesSet = _calculateRisks(this._featuresStates, this.data.featuresIdsMap, this.data.calculationConfig);
    // const r = Math.max(...this.valuesSet) / 100;
    this._totalRisk = this.data.calculationConfig.factor * this.valuesSet.reduce((accumulator = 0, val) => {return accumulator + val;}) / (this.valuesSet.length * 100);
};

const _calculateRisks = (states, map, config) => {
    const multiplyArrays = (arr1, arr2, a = 1) => {
        if (arr1.length <= arr2.length)
            return arr1.map((v, i) => {
                return v * arr2[i] * a
            });

        return arr2.map((v, i) => {
            return v * arr1[i] * a
        });
    };

    const mergeMasks = (arr1, arr2) => {
        if (arr1.length <= arr2.length)
            return arr1.map((v, i) => {
                return v + arr2[i]
            });

        return arr2.map((v, i) => {
            return v + arr1[i]
        });
    };

    let mask = null;
    let i;
    for (i = 0; i < states.length; i++) {
        if (!states[i]) continue;
        if (mask) mask = mergeMasks(mask, config.features[map[i]]);
        else mask = config.features[map[i]];
    }

    if (!mask)
        return 0;


    return multiplyArrays(mask, config.risks);
};

const _init = function (model) {
    model.defaultValuesSet = [].concat(model.data.valuesMap.none);
    model.valuesSet = [].concat(model.data.valuesMap.none);
    model._selectedReviewIndex = 0;

    model._featuresStates = model.data.featuresIdsMap.map(() => false);
    model.numFeatures = model._featuresStates.length;
    model._selectedFixIndex = -1;
    model._selectedFixI = -1;
    model._totalRisk = 0;
    model._featuresSelected = [];

}

const Model = {
    data: _initData(),
    selectedPreset: 'none',
    defaultValuesSet: [],
    valuesSet: [],
    isValuesSetBlank: true
};
_init(Model);

Model.getSelectedPresetValues = _getSelectedPresetValues.bind(Model);
Model.selectPreset = _selectPreset.bind(Model);
Model.getValuesSet = _getValuesSet.bind(Model);
Model.selectReviewItem = _selectReviewItem.bind(Model);
Model.selectFixItem = _selectFixItem.bind(Model);
Model.nextFixItem = _nextFixItem.bind(Model);
Model.getSelectedReviewItemId = _getSelectedReviewItemId.bind(Model);
Model.getSelectedReviewItemI = _getSelectedReviewItemI.bind(Model);
Model.getSelectedReviewCurrentValue = _getSelectedReviewCurrentValue.bind(Model);
Model.getSelectedFixItemId = _getSelectedFixItemId.bind(Model);
Model.getSelectedFixIndex = _getSelectedFixIndex.bind(Model);
Model.getFeatureItemId = _getFeatureItemId.bind(Model);
Model.getSelectedFeatureItemsIds = _getSelectedFeatureItemsIds.bind(Model);
Model.toggleFeature = _toggleFeature.bind(Model);
Model.getFeaturesStates = _getFeaturesStates.bind(Model);
Model.getFeatureState = _getFeatureState.bind(Model);
Model.getTotalRisk = _getTotalRisk.bind(Model);
Model.getRisks = _getRisks.bind(Model);

module.exports = Model;


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/Model.js